import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ExpertSection() {
  return <section className="py-16 bg-brand-green/10 border-y-4 border-brand-green/30" data-id="element-86">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-88">
          <div className="w-full md:w-1/3" data-id="element-89">
            <div className="aspect-square rounded-full overflow-hidden relative border-4 border-brand-yellow/50 shadow-xl" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/3EGPqjgepoRMQ2tTvDs84F/dra_montessori.png" alt="Dra. Montessori - Experta en desarrollo infantil" className="w-full h-full object-cover" data-id="element-91" />
            </div>
          </div>

          <div className="w-full md:w-2/3" data-id="element-92">
            <h3 className="text-2xl font-bold text-brand-navy mb-4 font-serif" data-id="element-93">
              Criterios de un sistema efectivo
            </h3>
            <p className="text-slate-700 mb-6" data-id="element-94">
              Para reducir el tiempo de pantalla de forma sostenible, no basta
              con prohibir. Necesitas reemplazar el hábito con algo igual de
              gratificante pero saludable.
            </p>

            <ul className="space-y-3" data-id="element-95">
              {[{
              text: 'Debe ser simple (menos de 10 segundos para empezar)',
              color: 'text-brand-red'
            }, {
              text: 'Debe funcionar cuando tú estás cansada (baja fricción)',
              color: 'text-brand-orange'
            }, {
              text: 'Debe crear hábitos autónomos, no depender de tu motivación',
              color: 'text-brand-green'
            }, {
              text: 'Debe ofrecer una recompensa intrínseca inmediata al niño',
              color: 'text-brand-navy'
            }].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-96">
                  <CheckCircle2 className={`w-5 h-5 ${item.color} flex-shrink-0 mt-0.5`} data-id="element-97" />
                  <span className="text-slate-700 text-sm" data-id="element-98">{item.text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}